export interface Activity {
  id: number;
  userId: number;
  message: string;
  createdAt: string;
}
export type Stats = Stat[];
export interface Stat {
  value: number;
  label: string;
  totalAccount: number;
}

export interface SelectOption {
  value: number | string;
  label: string;
  type: string;
}

export type GroupedActivities = Array<{ [key: string]: Activity[] }>;

export const AssertEnum = 'Bank' || 'Stock'; // || 'Pension' | 'Physical' | 'Bond' | 'Benefit';

export type DashStats = DashStat[];

export interface DashStat {
  pageId: number;
  name: string;
  icon?: string;
  totalAccount: number;
  totalBeneficiary: number;
  totalAssigned: number;
  pageUrl: string;
}

export type ApiPaginationOptions = {
  page: number;
  take: number;
  order: string;
};

export type PaginatedListMeta = {
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  itemCount: number;
  page: number;
  pageCount: number;
  take: number;
};

export enum ListOrder {
  ASC = 'ASC',
  DESC = 'DESC'
}

export interface Plan {
  id: number;
  planId: number;
  image: string;
  planType: string;
  planDesc: string;
  isRecommended: number;
  isSelectedPlan: number;
  packages: Package[];
  allowPage: number[];
  price: number;
}

export interface Package {
  title: string;
  info: string;
  surveyKey: string;
}
